import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaStar, FaQuoteLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { testimonials } from '../../data/hotelData';
import './Testimonials.css';

export default function Testimonials() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent(c => (c - 1 + testimonials.length) % testimonials.length);
  const next = () => setCurrent(c => (c + 1) % testimonials.length);

  return (
    <section className="section testimonials-section">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Guest Reviews</span>
          <h2 className="section-title">What Our Guests Say</h2>
          <div className="gold-line" />
          <p className="section-subtitle">
            Hear from our guests about their unforgettable experiences at Grand Luxe Hotel & Spa.
          </p>
        </div>

        <div className="testimonials-layout">
          <div className="testimonials-image-col">
            <AnimatePresence mode="wait">
              <motion.img
                key={current}
                src={testimonials[current].avatar}
                alt={testimonials[current].name}
                className="testimonial-main-avatar"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.4 }}
              />
            </AnimatePresence>
            <div className="testimonials-thumbs">
              {testimonials.map((t, i) => (
                <img
                  key={t.id}
                  src={t.avatar}
                  alt={t.name}
                  className={`thumb-avatar ${i === current ? 'active' : ''}`}
                  onClick={() => setCurrent(i)}
                />
              ))}
            </div>
          </div>

          <div className="testimonials-content-col">
            <AnimatePresence mode="wait">
              <motion.div
                key={current}
                className="testimonial-card"
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -30 }}
                transition={{ duration: 0.5 }}
              >
                <FaQuoteLeft className="quote-icon" />

                <div className="testimonial-stars">
                  {[...Array(testimonials[current].rating)].map((_, i) => (
                    <FaStar key={i} />
                  ))}
                </div>

                <p className="testimonial-text">"{testimonials[current].comment}"</p>

                <div className="testimonial-author">
                  <strong>{testimonials[current].name}</strong>
                  <span>{testimonials[current].location} · {testimonials[current].date}</span>
                </div>
              </motion.div>
            </AnimatePresence>

            <div className="testimonials-nav">
              <button className="testimonial-btn" onClick={prev}><FaChevronLeft /></button>
              <div className="testimonial-dots">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    className={`t-dot ${i === current ? 'active' : ''}`}
                    onClick={() => setCurrent(i)}
                  />
                ))}
              </div>
              <button className="testimonial-btn" onClick={next}><FaChevronRight /></button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
